import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectRewardDTO } from '../../types/apiType';

export interface RewardState {
  selectedReward: ProjectRewardDTO | null;
}

const initialState: RewardState = {
  selectedReward: null,
};

export const rewardSlice = createSlice({
  name: 'reward',
  initialState,
  reducers: {
    setSelectedReward: (state, action: PayloadAction<ProjectRewardDTO | null>) => {
      state.selectedReward = action.payload;
    },
  },
});

export const { setSelectedReward } = rewardSlice.actions;

export default rewardSlice.reducer;
